export default {
    data: () => ({
        translations: {
            createSupplier: {
                el: "Προσθήκη Προμηθευτή",
                en: "Create Supplier",
                it: "Aggiungere un fornitore"
            },
            name: {
                el: "Name",
                en: "Name",
                it: "Nome"
            },
            email: {
                el: "Email",
                en: "Email",
                it: "Email"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            deleteReward: {
                el: "Διαγραφή Επιβράβευσης",
                en: "Delete Reward",
                it: "Cancellare il Premio"
            },
            deleteConfirmationMessage: {
                el: "Σίγουρα θέλεις να διαγράψεις την επιβράβευση",
                en: "Are you sure you want to delete",
                it: "Siete sicuri di voler eliminare"
            },
            questionmark: {
                el: ";",
                en: "?",
                it: "?"
            },
            createNewReward: {
                el: "Δημιουργία νέας επιβράβευσης",
                en: "Create New Reward",
                it: "Creare un nuovo premio"
            },
            activatedCampaignTitle: {
                el: "Ενεργοποίηση Kαμπάνιας",
                en: "Activate Campaign",
                it: "Attivare la Campagna"
            },
            activatedCampaignText: {
                el: "Σίγουρα θέλετε να ενεργοποιήσετε τη συγκεκριμένη καμπάνια;",
                en: "Are you sure you want to activate this particular campaign?",
                it: "È sicuro di voler attivare questa particolare campagna?"
            },
            canceledCampaignTitle: {
                el: "Ακύρωση Kαμπάνιας",
                en: "Cancel Campaign",
                it: "Annullamento della Campagna"
            },
            canceledCampaignText: {
                el: "Σίγουρα θέλετε να ακυρώσετε τη συγκεκριμένη καμπάνια;",
                en: "Are you sure you want to cancel this particular campaign?",
                it: "È sicuro di voler cancellare questa particolare campagna?"
            },
            rewardId:{
                el: "ID",
                en: "ID",
                it: "ID"
            },
            title: {
                el: "Τίτλος",
                en: "Title",
                it: "Titolo"
            },
            points:{
                el: "Πόντοι",
                en: "Points",
                it: "Punti"
            },
            coupons:{
                el: "Κουπόνια",
                en: "Coupons",
                it: "Buoni"
            },
            notifications: {
                el: "Ειδοποιήσεις",
                en: "Notifications",
                it: "Notifiche"
            }, 
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            // actions: {
            //     el: "Ενέργειες",
            //     en: "Actions",
            //     it: "Azioni"
            // },
            // rewardId:{
            //     el: "ID",
            //     en: "ID",
            //     it: "ID"
            // },
            // rewardId:{
            //     el: "ID",
            //     en: "ID",
            //     it: "ID"
            // },
        }
    })
};
